'use client';
import { Label } from '@radix-ui/react-label';

import { convertToEnglishDigits } from '@shared/lib';
import {
  Button,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
  Fundaward,
  Input,
  LoadingSpinner,
} from '@shared/ui';

import { TFundAwardFormProps, formLanguage } from '../../model';

import { Modal } from './Modal';

export const FundAwardForm = ({
  form,
  onSubmit,
  isLoading,
  open,
  setOpen,
  data,
}: TFundAwardFormProps) => {
  return (
    <div className='flex flex-col gap-4 items-center justify-center'>
      <Fundaward />
      <Form {...form}>
        <form
          onSubmit={form.handleSubmit(onSubmit)}
          className='flex flex-col gap-4 items-center justify-center w-[444px]'
        >
          <Label className='h5-bold'>{formLanguage.formPlaceholder}</Label>
          <FormField
            name='code'
            control={form.control}
            render={({ field }) => (
              <FormItem className='w-full mb-9'>
                <FormControl>
                  <Input
                    {...field}
                    dir='rtl'
                    className='h-[54px] placeholder:!body-12-regular w-full !body-14-regular mx-0 '
                    placeholder={formLanguage.formPlaceholder}
                    type='text'
                    value={field.value || ''}
                    maxLength={15}
                    onChange={(e) => {
                      const cleanedValue = convertToEnglishDigits(e.target.value).replace(
                        /[^A-Za-z0-9]/g,
                        ''
                      );
                      field.onChange(cleanedValue);
                    }}
                  />
                </FormControl>
                <FormMessage className='absolute' />
              </FormItem>
            )}
          />
          <Button
            disabled={isLoading}
            className='h-[60px] w-full gap-x-1 items-center flex justify-center  grow'
            type='submit'
          >
            {isLoading && <LoadingSpinner className='text-pics scale-[0.6]' />}
            {formLanguage.applyButton}
          </Button>
        </form>
      </Form>
      <Modal open={open} setOpen={setOpen} data={data} />
    </div>
  );
};
